import React from "react";
import Loader from "react-loader-spinner";
import classes from "./style.module.scss";

export const LoadingIndicator = ({ height, width }) => {
  return (
    <div className={classes["loader-indicator"]}>
      <Loader
        type="Circles"
        color="rgb(73, 122, 122)"
        height={height || 75}
        width={width || 75}
        
      />
    </div>
  );
};

export default LoadingIndicator;
